import { createWidget } from '@typeform/embed'
import '@typeform/embed/build/css/widget.css'

export default {
	namespace: 'contact',
	beforeEnter(barba) {
		createWidget('vVey3RmU', {
			container: barba.next.container.querySelector('#contactForm'),
			hideHeaders: true,
			hideFooter: true,
			opacity: 0,
		})
	},
	afterEnter() {
		console.log('View: survey')
	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
